(function () {
  function bindDrawerShopAllToggleCleanup() {
    document.querySelectorAll('details.menu-drawer__details--shop-all').forEach((details) => {
      if (details.dataset.shopAllDrawerToggleBound) return;
      details.dataset.shopAllDrawerToggleBound = 'true';
      details.addEventListener('toggle', () => {
        window.setTimeout(() => {
          if (details.open) return;
          const ul = details.closest('.has-submenu');
          ul?.classList.remove('submenu-open');
          details.classList.remove('menu-opening');
          const sum = details.querySelector('summary');
          sum?.setAttribute('aria-expanded', 'false');
        }, 120);
      });
    });
  }

  function init() {
    bindDrawerShopAllToggleCleanup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
